module.exports = __webpack_public_path__ + "img/tips-icon.b7c27801.jpg";